import { render, staticRenderFns } from "./ModalUrl.vue?vue&type=template&id=58a99b95&scoped=true"
import script from "./ModalUrl.vue?vue&type=script&lang=js"
export * from "./ModalUrl.vue?vue&type=script&lang=js"
import style0 from "./ModalUrl.vue?vue&type=style&index=0&id=58a99b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a99b95",
  null
  
)

export default component.exports